import React, { useState } from 'react'
import G2ReviewModal from 'src/component-modal/G2ReviewModal/G2ReviewModal'
import Box from 'src/components/Box/Box'
import Button, {
  ButtonDesigns,
  ButtonTypes,
} from 'src/components/Button/Button'
import { useTranslate } from 'src/localization/Trns'

import style from './G2ReviewBox.style'

const G2ReviewBox: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const translate = useTranslate()

  return (
    <>
      <Box css={style} className="G2ReviewBox" data-testid="g2-review-box">
        <span className="G2ReviewBox-title">
          {translate('A little review goes a long way')}
        </span>
        <span className="G2ReviewBox-description">
          {translate('Share your experience with others on G2!')}
        </span>
        <div className="G2ReviewBox-button">
          <Button
            type={ButtonTypes.button}
            design={ButtonDesigns.designCta}
            text={translate('Leave a review')}
            onClick={() => setIsModalOpen(true)}
            big
          />
        </div>
      </Box>
      <G2ReviewModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  )
}

export default G2ReviewBox
